// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3keQN","footer":"ModalError_footer__3Q8Xx"};